import type { GetPromotedPartnerGamesBody } from 'src/types/partner-games';
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const STORE_NAME = 'PartnerGames';

type PromotedGamesFiltersType = {
  brands: GetPromotedPartnerGamesBody['brands'];
};

export type PartnerGamesStoreState = {
  promotedMappedGamesFilters: PromotedGamesFiltersType;
  promotedUnmappedGamesFilters: PromotedGamesFiltersType;
  setPromotedMappedGamesFilters: (promotedMappedGamesFilters: PromotedGamesFiltersType) => void;
  setPromotedUnmappedGamesFilters: (promotedUnmappedGamesFilters: PromotedGamesFiltersType) => void;
  setInitialPromotedMappedGamesFilters: () => void;
  setInitialPromotedUnmappedGamesFilters: () => void;
};

const initialState = {
  promotedMappedGamesFilters: {
    brands: [],
  },
  promotedUnmappedGamesFilters: {
    brands: [],
  },
};

export const usePartnerGamesStore = create<PartnerGamesStoreState>()(
  devtools(
    (set) => ({
      ...initialState,
      setPromotedMappedGamesFilters: (promotedMappedGamesFilters) => set(() => ({ promotedMappedGamesFilters })),
      setPromotedUnmappedGamesFilters: (promotedUnmappedGamesFilters) => set(() => ({ promotedUnmappedGamesFilters })),
      setInitialPromotedMappedGamesFilters: () =>
        set(() => ({ promotedMappedGamesFilters: initialState.promotedMappedGamesFilters })),
      setInitialPromotedUnmappedGamesFilters: () =>
        set(() => ({ promotedUnmappedGamesFilters: initialState.promotedUnmappedGamesFilters })),
    }),
    { name: STORE_NAME },
  ),
);
